<template>
  <v-container class="intake-form-page" v-if="hasAccessToPage" fluid>
    <v-row justify="start" class="mx-4 pt-0">
      <v-col cols="12" lg="12" xl="11">
        <DoctorCodesForm />
      </v-col>
    </v-row>
  </v-container>
  <NoAccessMessage v-else />
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';
import DoctorCodesForm from '@/views/DoctorCodesPage/components/doctor-codes-form.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    NoAccessMessage,
    DoctorCodesForm
  },
  data() {
    return {
      hasAccessToPage: false
    };
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
  },
  methods: {}
};
</script>

<style>
</style>
